import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'
import { dataSource} from '../../../services/dataSource'
import { CLI, CLI_V2, PROP, REP_TPL, REP_V2, USR } from '../../../shared/Data/typeDirs'
import { useNavigate, useLocation } from 'react-router-dom'

export const AllReportsContextClass = createContext(null)

export function AllReportsContext({
  children,
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const [state, setState] = useState({ reports_v2: [], clients: [], clients_v2: [], properties: [] })
  const currentHistoryPath = useMemo(()=> location.pathname, [location.pathname]) 

  useEffect(() => {
    let stillAlive = true
    // console.log('why 4 times', currentHistoryPath)
    let t_id = setTimeout(async () => {
      try {
        let newState
        if (currentHistoryPath === '/home') newState = await init()
        if (stillAlive && newState) {
			console.log('setting all data', newState)
			setState(newState)
		}
      } catch (error) {
        console.error('Error initializing reports:', error)
      }
    })
    return () => {
      stillAlive = false
      clearTimeout(t_id)
    }
  }, [currentHistoryPath])

  const value = useMemo(() => ({
    ...state, initAllData: async () => {
      try {
        const res = await init()
        setState(res)
      } catch (error) {
        console.error('Error in initAllData:', error)
      }
    }
  }), [state])

  function handleReportClick(report) {
    navigate(`/reports/${report._id}`)
  }

  return (
    <AllReportsContextClass.Provider value={value}>
      {children}
    </AllReportsContextClass.Provider>
  )
}

export function useAllReportsContext() {
  return useContext(AllReportsContextClass)
}

function sortByName(a, b) {
  return a.name > b.name ? 1 : -1
}

async function init() {
  let newState = {}
  for (let type of [REP_V2, CLI, CLI_V2, PROP, USR, REP_TPL]) {
    newState[type] = await dataSource('remDb')[type].toFlatArray()
    if(type === USR ) newState[type] = newState[type].map(itm=>({...itm, name: `${itm.firstName} ${itm.lastName}` }))
    if(type !== REP_V2){
      newState[type] = newState[type].sort(sortByName);
    }
  }
  return newState
}

